<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    role="group"
    class='agpr-curatorBlock'
    [ngClass]="{
        'agpr-curatorBlock--editing': editing,
        'agpr-curatorBlock--cannot-move': !block.canMove,
        'agpr-curatorBlock--disabled': !block.actionable,
        'agpr-curatorBlock--error': block.errors?.length
    }"
    tabindex="0"
    [attr.aria-label]="'Pagebuilder.block.label' | localize: { index: +blockPosition + 1, type: block.type?.label }"
    [attr.aria-describedby]="id + '_errors'"
    (click)="onAction('edit', $event)"
>
    @if (block.actionable) {
        @if (showMoveButtons && block.canMove) {
            <agpr-kebab-menu
                #moveContextMenu
                class="agpr-curatorBlock-contextMenu agpr-curatorBlock-contextButton agpr-curatorBlock-contextMenu--topLeft--outside"
                [id]="id + '_move'"
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-arrows-up-down-left-right"
                [panelPositionX]="panelPositions.left"
                [disabled]="!block.canMoveUp && !block.canMoveDown"
                [options]="movingOptions"
                [showIcon]="true"
                [loading]="null"
                tooltip="PageBuilder.blockIcon.move"
                tooltipPosition="top"
            ></agpr-kebab-menu>
        }
        <ul
            role="menu"
            class="agpr-curatorBlock-contextMenu agpr-curatorBlock-contextMenu--topRight--outside"
            [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
        >
            @if (block.canDuplicate) {
                <li role="menuitem">
                    <agpr-button
                        class="agpr-curatorBlock-contextButton agpr-curatorBlock-contextButton--topLeft"
                        [id]="id + '_duplicate'"
                        [style]="buttonTypes.contextMenu"
                        icon="fa-regular fa-duotone fa-clone"
                        tooltip="PageBuilder.briefings.blockIcon.duplicate"
                        tooltipPosition="top"
                        (click)="onAction('duplicate')"
                    ></agpr-button>
                </li>
            }
            @if (block.canEdit) {
                <li role="menuitem">
                    <agpr-button
                        class="agpr-curatorBlock-contextButton"
                        [id]="id + '_edit'"
                        [style]="buttonTypes.contextMenu"
                        icon="fa-regular fa-duotone fa-pen"
                        tooltip="PageBuilder.briefings.blockIcon.edit"
                        tooltipPosition="top"
                        (click)="onAction('edit')"
                    ></agpr-button>
                </li>
            }
            @if (block.canAddOrRemove) {
                <li role="menuitem">
                    <agpr-button
                        class="agpr-curatorBlock-contextButton agpr-curatorBlock-contextButton--topRight"
                        [id]="id + '_delete'"
                        [style]="buttonTypes.contextMenu"
                        icon="fa-regular fa-duotone fa-trash-can"
                        tooltip="PageBuilder.briefings.blockIcon.delete"
                        tooltipPosition="top"
                        (click)="onAction('delete')"
                    ></agpr-button>
                </li>
            }
        </ul>
        <ul
            #addToTop
            role="menu"
            class="agpr-curatorBlock-contextMenu agpr-curatorBlock-contextMenu--center-top"
            [ngClass]="{ 'agpr-curatorBlock-contextMenu--hidden': addBottomExpanded }"
            [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
            (mouseleave)="leaveContextMenu(addToTop, $event, true, 'agpr-curatorBlock')"
        >
            <li role="menuitem">
                 @if (inlineAdderAdjustment) {
                    <agpr-kebab-menu
                        class="agpr-curatorBlock-contextButton agpr-curatorBlock-contextButton--topLeft agpr-curatorBlock-contextButton--topRight agpr-inline-addTop-button"
                        [id]="id + '_addTop_moreOptions'"
                        icon="fa-regular fa-duotone fa-plus"
                        [style]="buttonTypes.contextMenu"
                        [panelPositionX]="panelPositions.right"
                        [options]="optionsTop"
                        [showIcon]="true"
                        [loading]="null"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                        [panelAlignCenter]="true"
                        [textAlignment]="actionMenuTextAlignment"
                    ></agpr-kebab-menu>
                }@else {
                    <agpr-button
                        [id]="id + '_addTop'"
                        class="agpr-curatorBlock-contextButton agpr-curatorBlock-contextButton--topLeft agpr-curatorBlock-contextButton--topRight agpr-inline-addTop-button"
                        icon="fa-regular fa-duotone fa-plus"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                        [expanded]="addTopExpanded"
                        (click)="inlineAddToggle($event, null, 'agpr-curatorBlock')"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                    <div
                        class="agpr-curatorBlock-contextMenu-adderContainer"
                        (focusout)="leaveContextMenu(addToTop, $event, false, 'agpr-curatorBlock')"
                    >
                        <div class="agpr-curatorBlock-contextMenu-adder">
                            <label class="agpr-curatorBlock-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                            <agpr-block-adder
                                [id]="id + '_above_' + blockAdderId"
                                [addAtPosition]="blockPosition"
                            ></agpr-block-adder>
                            @if (areLayoutBlocksAllowed) {
                                <label class="agpr-curatorBlock-contextMenu-adder-header agpr-curatorBlock-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                <agpr-layout-block-adder
                                    [id]="id + '_above_' + blockAdderId + '_layout'"
                                    [addAtPosition]="blockPosition"
                                    [isInline]="true"
                                ></agpr-layout-block-adder>
                            }
                        </div>
                    </div>
                }
            </li>
        </ul>
        <ul
            #addToBottom
            role="menu"
            class="agpr-curatorBlock-contextMenu agpr-curatorBlock-contextMenu--center-bottom"
            [ngClass]="{'agpr-curatorBlock-contextMenu--hidden': addTopExpanded}"
            [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
            (mouseleave)="leaveContextMenu(addToBottom, $event, true, 'agpr-curatorBlock')"
        >
            <li role="menuitem">
                @if (inlineAdderAdjustment) {
                    <agpr-kebab-menu
                        class="agpr-curatorBlock-contextButton agpr-curatorBlock-contextButton--bottomLeft agpr-curatorBlock-contextButton--bottomRight"
                        [id]="id + '_addBottom_moreOptions'"
                        icon="fa-regular fa-duotone fa-plus"
                        [style]="buttonTypes.contextMenu"
                        [panelPositionX]="panelPositions.right"
                        [options]="optionsBottom"
                        [showIcon]="true"
                        [loading]="null"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                        [panelAlignCenter]="true"
                        [textAlignment]="actionMenuTextAlignment"
                    ></agpr-kebab-menu>
                }@else {
                    <agpr-button
                        class="agpr-curatorBlock-contextButton agpr-curatorBlock-contextButton--bottomLeft agpr-curatorBlock-contextButton--bottomRight agpr-inline-addTop-button"
                        [id]="id + '_addBottom'"
                        icon="fa-regular fa-duotone fa-plus"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="bottom"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                        [expanded]="addBottomExpanded"
                        (click)="inlineAddToggle($event, null, 'agpr-curatorBlock')"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                    <div class="agpr-curatorBlock-contextMenu-adderContainer">
                        <div
                            class="agpr-curatorBlock-contextMenu-adder"
                            (focusout)="leaveContextMenu(addToBottom, $event, false, 'agpr-curatorBlock')"
                        >
                            <label class="agpr-curatorBlock-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                            <agpr-block-adder
                                [id]="id + '_below_' + blockAdderId"
                                [addAtPosition]="blockPositionBottom"
                                [hideBlockTypes]="['chart', 'coverage_curator']"
                            ></agpr-block-adder>
                            @if (areLayoutBlocksAllowed) {
                                <label class="agpr-curatorBlock-contextMenu-adder-header agpr-curatorBlock-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                <agpr-layout-block-adder
                                    [id]="id + '_below_' + blockAdderId + '_layout'"
                                    [addAtPosition]="blockPositionBottom"
                                    [isInline]="true"
                                ></agpr-layout-block-adder>
                            }
                        </div>
                    </div>
                }
            </li>
        </ul>
    }

    <div
        class="agpr-curatorBlock-banner"
    >
        <span class="fa-kit-duotone fa-agpr-ai-coverage"></span>
        <span> {{ 'PageBuilder.blockType.curator' | localize}} </span>
        @if (showEmptySectionWarning) {
            <span
                class="fa-regular fa-circle-info agpr-curatorBlock-banner-infoIcon"
                aria-hidden="true"
                agprTooltip="PageBuilder.curatorBlock.emptySectionWarning.tooltip"
                tooltipPosition="top"
                [tooltipAllowsHtml]="true"
            ></span>
        }
    </div>

    @if (block.displayElement.styles?.['padding']?.paddingOption === true) {
        <div
            class="agpr-curatorBlock-container"
            [id]="id"
            [attr.data-blocktype]="dataBlockType"
            [style.background-color]="block.displayElement.styles?.['backgroundColor']"
            [style.padding-top]="block.displayElement.styles['padding'].topPadding + 'px'"
            [style.padding-right]="block.displayElement.styles['padding'].rightPadding + 'px'"
            [style.padding-bottom]="block.displayElement.styles['padding'].bottomPadding + 'px'"
            [style.padding-left]="block.displayElement.styles['padding'].leftPadding + 'px'"
        >
            <ng-container *ngTemplateOutlet="columnTemplate; context: { block: block }"></ng-container>
        </div>
    } @else {
        <div
            class="agpr-curatorBlock-container"
            [id]="id"
            [attr.data-blocktype]="dataBlockType"
            [style.background-color]="block.displayElement.styles?.['backgroundColor']"
            [style.padding]="block.displayElement.styles['padding'].paddingAll + 'px'"
        >
            <ng-container *ngTemplateOutlet="columnTemplate; context: { block: block }"></ng-container>
        </div>
    }

    <ng-template #columnTemplate let-block="block">
        <div
            class="agpr-curatorBlock-column"
        >
            @if (block?.blocks?.length > 0) {
                @if (disableDrop) {
                    <ul
                        class="agpr-curatorBlock-column-list"
                    >
                        <ng-container *ngTemplateOutlet="blockListTemplate; context: { column: block.blocks, block: block, blockPosition: blockPosition }"></ng-container>
                    </ul>
                } @else {
                    <ul
                        class="agpr-curatorBlock-column-list"
                        [dndDropzone]="['block', 'blockType']"
                        dndEffectAllowed="copyMove"
                        (dndDrop)="onDropBlocks($event, 0)"
                    >
                        <li
                            dndPlaceholderRef
                            class="agpr-drag-placeholder"
                        ></li>
                        <ng-container *ngTemplateOutlet="blockListTemplate; context: { column: block.blocks, block: block, blockPosition: blockPosition }"></ng-container>
                    </ul>
                }
                <ng-template #blockListTemplate let-column="column" let-blockPosition="blockPosition" let-block="block">
                    @for (blockModel of column; track blockModel; let j = $index) {
                        <li
                            [dndDraggable]="j"
                            dndEffectAllowed="move"
                            dndType="block"
                            [dndDisableIf]="!block.draggable"
                            (dndStart)="onDragBlockStart(blockModel, blockPosition + '.0.' + j)"
                            (dndEnd)="onDragBlockComplete()"
                            (click)="preventPropagation($event)"
                        >
                            <agpr-block-wrapper
                                [block]="blockModel"
                                [blockPosition]="blockPosition + '.0.' + j"
                                [isInCuratorBlock]="true"
                                [isRightMost]="true"
                                [actionMenuTextAlignment]="actionMenuTextAlignment"
                            ></agpr-block-wrapper>
                        </li>
                    }
                </ng-template>
            } @else {
                @if (disableDrop) {
                    <div
                        #addComponent
                        class="agpr-curatorBlock-placeholder agpr-curatorBlock-contextMenu"
                        [ngClass]="{ 'agpr-curatorBlock-placeholder--adderOpened': openedPlaceholderIndex === 0 }"
                        [style.height]="placeholderHeight + 'px'"
                        (click)="inlineAddToggle($event, null, 'agpr-curatorBlock', 0)"
                        (mouseleave)="leaveContextMenu(addComponent, $event, true, 'agpr-curatorBlock')"
                    >
                        <ng-container *ngTemplateOutlet="blockPlaceholderTemplate; context: { index: 0, id: id, blockPosition: blockPosition, buttonTypes: buttonTypes }"></ng-container>
                    </div>
                } @else {
                    <div
                        #addComponent
                        class="agpr-curatorBlock-placeholder agpr-curatorBlock-contextMenu"
                        [ngClass]="{ 'agpr-curatorBlock-placeholder--adderOpened': openedPlaceholderIndex === 0 }"
                        [style.height]="placeholderHeight + 'px'"
                        [dndDropzone]="['block', 'blockType']"
                        dndEffectAllowed="copyMove"
                        dndDragoverClass="agpr-curatorBlock-placeholder--dragover"
                        (dndDrop)="onDropBlocks($event, 0)"
                        (click)="inlineAddToggle($event, null, 'agpr-curatorBlock', 0)"
                        (mouseleave)="leaveContextMenu(addComponent, $event, true, 'agpr-curatorBlock')"
                    >
                        <ng-container *ngTemplateOutlet="blockPlaceholderTemplate; context: { index: 0, id: id, blockPosition: blockPosition, buttonTypes: buttonTypes }"></ng-container>
                    </div>
                }
                <ng-template #blockPlaceholderTemplate let-i="index" let-id="id" let-blockPosition="blockPosition" let-buttonTypes="buttonTypes">
                    <label class="agpr-curatorBlock-placeholder-header">{{ 'PageBuilder.layoutBlock.placeholder.label' | localize }}</label>
                    <span class="agpr-curatorBlock-inlineAdder-icon fa-regular fa-duotone fa-square-plus" aria-hidden="true"></span>
                    <div class="agpr-curatorBlock-contextMenu-adderContainer">
                        <div
                            class="agpr-curatorBlock-contextMenu-adder agpr-curatorBlock-contextMenu-adder--withinBlock"
                            [style.top]="placeholderHeight - 2 + 'px'"
                            (focusout)="leaveContextMenu(addComponent, $event, false, 'agpr-curatorBlock')"
                        >
                            <label class="agpr-curatorBlock-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                            <agpr-block-adder
                                [id]="id + '_below_' + blockAdderId"
                                [addAtPosition]="blockPosition + '.' + i + '.0'"
                                [hideBlockTypes]="['chart', 'coverage_curator']"
                            ></agpr-block-adder>
                            @if (areLayoutBlocksAllowed) {
                                <label class="agpr-curatorBlock-contextMenu-adder-header agpr-curatorBlock-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                <agpr-layout-block-adder
                                    [id]="id + '_above_' + blockAdderId + '_layout'"
                                    [addAtPosition]="blockPosition + '.' + i + '.0'"
                                    [isInline]="true"
                                    [disabled]="true"
                                ></agpr-layout-block-adder>
                            }
                        </div>
                    </div>
                </ng-template>
            }
        </div>
    </ng-template>

    <div class="agpr-curatorBlock-hoverBorder"></div>
</div>
<div [id]="id + '_errors'" *ngIf="block.errors?.length > 0" class="agpr-curatorBlockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error | localize }}
    </agpr-form-message>
</div>
